export const institutionsMapper = <T>(institutionsReceived: T): T => {
  return (institutionsReceived as any).map((i: any) => ({
    ...i,
    image:
      'https://s3.eu-central-1.amazonaws.com/com.coinscrap.others/public/banks/icons/' +
      i.identifier +
      '.png',
  }));
};
